<style lang="less" rel="stylesheet/less" scoped>
.filter::-webkit-scrollbar {
  width: 6px;
  background-color: #f1f3f4;
}
/* scroll轨道背景 */
/* ::-webkit-scrollbar-track {
    border-radius: 10px;
    background-color: yellow;
} */

/* 滚动条中能上下移动的小块 */
.filter::-webkit-scrollbar-thumb {
  height: 80px;
  border-radius: 6px;
  background-color: #cccccc;
}
.tool {
  position: absolute;
  z-index: 1000;
  top: 0;
  right: 0;
  width: 560px;
  height: 100%;
  border-radius: 24px 0px 0px 24px;
  background: #f1f3f4;
  float: right;
  text-align: left;
  // padding-top:85px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background: #425bc2;
  .filter {
    flex: 1;
    overflow-y: scroll;
    margin-top: 50px;
  }
  .filterbox {
    display: flex;
    padding-left: 30px;
    margin-bottom: 25px;
    p {
      color: #fff;
      font-weight: 600;
      font-size: 18px;
      margin-right: 20px;
      min-width: 40px;
      line-height: 45px;
    }
    span {
      display: inline-block;
      width: 100px;
      text-align: center;
      height: 45px;
      line-height: 45px;
      border-radius: 22px;
      margin-right: 15px;
      background: rgba(255, 255, 255, 0.2);
      color: #fff;
      font-size: 18px;
      margin-bottom: 35px;
    }
    // span:hover,
    .cur {
      color: #425bc2;
      font-weight: bold;
      background: rgba(255, 255, 255, 1);
    }
  }
  .btn {
    width: 100%;
    border-top: 1px solid #d8e3e6;
    margin: 0px auto 37px;
    display: flex;
    justify-content: center;
    button {
      width: 128px;
      height: 60px;
      border-radius: 30px;
      font-size: 20px;
      margin-top: 30px;
    }
    .reset {
      border: 2px solid #fff;
      color: #fff;
    }
    .confirm {
      background: #ffffff;
      color: #425bc2;
      margin-left: 25px;
    }
    .reset:hover {
      border-color: rgba(255, 255, 255, 0.8);
      color: rgba(255, 255, 255, 0.8);
    }
    .confirm:hover {
      background: rgba(255, 255, 255, 0.8);
      color: #425bc2;
    }
  }
}
</style>
<template>
  <div class="tool">
    <div class="filter">
      <div class="filterbox">
        <p>科目</p>
        <div class="right">
          <span
            v-for="(item, index) in subjectList"
            v-show="subjects.indexOf(item) != -1"
            :key="index"
            @click="checkLessonType(index, 'selfSubjectIndex')"
            :class="[index == selfSubjectIndex ? 'cur' : '', 'cursor']"
            >{{ item }}</span
          >
        </div>
      </div>
      <div class="filterbox">
        <p>状态</p>
        <div class="right">
          <span
            v-for="(item, index) in lessonList"
            :key="index"
            @click="checkLessonType(index, 'selfLessonIndex')"
            :class="[index == selfLessonIndex ? 'cur' : '', 'cursor']"
            >{{ item }}</span
          >
        </div>
      </div>
      <div class="filterbox">
        <p>阶段</p>
        <div class="right">
          <span
            v-for="(item, index) in gradeList"
            :key="index"
            v-show="classGrades.indexOf(index) != -1"
            @click="checkLessonType(index, 'selfGradeIndex')"
            :class="[index == selfGradeIndex ? 'cur' : '', 'cursor']"
            >{{ item }}</span
          ><span
            v-show="classGrades.indexOf(100) != -1"
            @click="checkLessonType(100, 'selfGradeIndex')"
            :class="[100 == selfGradeIndex ? 'cur' : '', 'cursor']"
            >不限</span
          >
        </div>
      </div>
      <div class="filterbox">
        <p>年份</p>
        <div class="right">
          <span
            v-for="(item, index) in classYears"
            :key="index"
            @click="checkLessonType(index, 'classYearIndex')"
            :class="[index == classYearIndex ? 'cur' : '', 'cursor']"
            >{{ item }}</span
          >
        </div>
      </div>
      <div class="filterbox">
        <p>学期</p>
        <div class="right">
          <span
            v-for="(item, index) in semesterList"
            :key="index"
            @click="checkLessonType(index, 'semesterIndex')"
            :class="[index == semesterIndex ? 'cur' : '', 'cursor']"
            >{{ item }}</span
          >
        </div>
      </div>
    </div>
    <div class="btn">
      <button class="reset cursor" @click="reset">重置</button>
      <button class="confirm cursor" @click="confirm">确定</button>
    </div>
  </div>
</template>
<script>
import { mapState, mapMutations } from "vuex";
export default {
  name: "tool",
  data() {
    return {
      subjectList: ["全部科目", "数理", "人文", "双语", "自然", "实验", "会计"],
      lessonList: ["全部课程", "学期中", "已结课"],
      semesterList: ["全部学期", "春季", "暑假", "秋季", "寒假"],
      // gradeList: [
      //   "全部年级",
      //   "一年级",
      //   "二年级",
      //   "三年级",
      //   "四年级",
      //   "五年级",
      //   "六年级",
      //   "七年级",
      //   "八年级",
      //   "九年级"
      // ],

      saveSetings: [
        "selfGradeIndex",
        "selfLessonIndex",
        "selfSubjectIndex",
        "semesterIndex",
        "classYearIndex",
      ],
    };
  },
  props: ["classYears", "classGrades", "subjects"],
  computed: {
    ...mapState([
      "classYearIndex",
      "semesterIndex",
      "selfGradeIndex",
      "selfLessonIndex",
      "selfSubjectIndex",
    ]),
    gradeList() {
      let grades = [
        "全部阶段",
        "L1",
        "L2",
        "L3",
        "L4",
        "L5",
        "L6",
        "L7",
        "L8",
        "L9",
        "G1",
        "G2",
        "G3",
      ];
      if (this.classGrades.indexOf(31) != -1) {
        grades[31] = "其他";
      }
      return grades;
    },
  },
  mounted() {},
  methods: {
    ...mapMutations(["saveTool", "saveToolIndex"]),
    checkLessonType(index, type) {
      console.log(247, index, type);
      this.saveToolIndex({ type, index });
      let res = {
        gradeIndex: this.selfGradeIndex,
        lessonIndex: this.selfLessonIndex,
        subjectIndex: this.selfSubjectIndex,
        classYear: this.classYears[this.classYearIndex],
        semesterIndex: this.semesterIndex,
      };
      console.log(253, res);
      this.saveTool(res);
    },
    confirm() {
      // this.$emit('checkLessonType',this.selfGradeIndex,this.selfLessonIndex,this.selfSubjectIndex);
      this.$emit("toolShow", false);
    },
    reset() {
      this.saveSetings.forEach((v) => {
        this.saveToolIndex({ type: v, index: 0 });
      });
      let res = {
        selfGradeIndex: this.selfGradeIndex,
        selfLessonIndex: this.selfLessonIndex,
        selfSubjectIndex: this.selfSubjectIndex,
        classYear: this.classYears[this.classYearIndex],
        semesterIndex: this.semesterIndex,
      };
      this.saveTool(res);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/bussiness/class/tool.vue